__webpack_require__.p = "/min-spannbaum/";